import { GenericModel } from "../../generic.model";
import { makeModel } from "../../../service/utils/utils.service";
import { KeywordModel } from "../common/keyword.model";
import { ServiceXCategoryModel } from "./serviceXCategory.model";
import {LocationArrayModel} from "./locationArray.model";


export class DictionaryModel extends GenericModel {
    public keywordArray: KeywordModel[];
    public serviceXCategoryArray: ServiceXCategoryModel[];
    public locationArray: LocationArrayModel[];
    // TODO locationArray: [{stationArray: [{xRef: "LS.DABT71"}], keyArray: ["DABT71"], xId: "L.DABT71"}, {keyArray: ["DABT71"]}]
    // TODO serviceArray: [{afid: "SVC_otac_EQP_13"}, {afid: "SVC_otac_EQP_35"}, {afid: "SVC_otac_EQP_54"},…]

    protected fromJson(json?: any): boolean {
        this.keywordArray = makeModel(json.keywordArray, KeywordModel);
        this.serviceXCategoryArray = makeModel(json.serviceXCategoryArray, ServiceXCategoryModel);
        this.locationArray = makeModel(json.locationArray, LocationArrayModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }
}